import { HttpClient } from '@angular/common/http';
import { AfterViewInit, Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { DialogService } from 'src/app/utils/dialog.service';
import { environment } from 'src/environments/environment';
import { helper } from 'src/environments/helper';
import { EditRegistruComponent } from '../../edit-registru/edit-registru.component';
import Swal from 'sweetalert2';

@Component({
    selector: 'app-avize',
    templateUrl: './avize.component.html',
    styleUrls: ['./avize.component.scss']
})
export class AvizeComponent implements OnInit, OnDestroy, AfterViewInit, OnChanges {
    @Input() isEditColumnVisible: boolean = false;
    @Input() registru_slug!: string;
    @Input() registru_type!: number;

    @Input() selectedStartDate!: string;
    @Input() selectedEndDate!: string;

    @ViewChild(DataTableDirective, { static: false })
    dtElement!: DataTableDirective;
    @Output() extractedDTparams = new EventEmitter();
    helper = helper;

    dtOptions: any = {};
    dtTrigger: Subject<any> = new Subject<any>();
    dtInstance!: DataTables.Api;
    isLoading = false;

    dtLink =
        environment.interop.basePath +
        environment.interop.urbanism.nomenclatoare.registru.listDT;

    constructor(
        private http: HttpClient,
        private dialog: MatDialog,
        private dialogService: DialogService,
    ) { }

    ngAfterViewInit(): void {
        this.dtTrigger.next('');
    }

    ngOnDestroy(): void {
        this.dtTrigger.unsubscribe();
    }

    ngOnInit(): void {
        this.renderDT();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['isEditColumnVisible'] && !changes['isEditColumnVisible'].firstChange) {
            this.toggleEditColumnVisibility();
        }
    }

    renderDT() {
        this.isLoading = true;

        this.dtOptions = {
            responsive: true,
            serverSide: true,
            searching: false,
            pageLength: 25,
            order: [[0, 'desc']],
            ajax: (dataTablesParameters: any, callback: any) => {
                this.isLoading = true;
                dataTablesParameters.type = this.registru_type;
                dataTablesParameters.slug = this.registru_slug;
                dataTablesParameters.date_from = this.selectedStartDate;
                dataTablesParameters.date_to = this.selectedEndDate;

                this.extractedDTparams.emit(dataTablesParameters);

                this.http
                    .post<any>(this.dtLink, dataTablesParameters)
                    .subscribe((resp: any) => {
                        this.isLoading = false;
                        callback({
                            recordsTotal: resp.data.recordsTotal,
                            recordsFiltered: resp.data.recordsFiltered,
                            data: resp.data.data,
                        });
                    });
            },
            language: environment.config.romanianLanguageDataTable,
            columns: [
                {
                    title: 'Număr aviz',
                    data: 'numar_aviz',
                    sortable: false,
                    render: (data: any, type: any, row: any) => {
                        if (row.numar_aviz) {
                            return `<span>${row.numar_aviz}</span>`;
                        } else {
                            return '<span>N/A</span>';
                        }
                    },
                },
                {
                    title: 'Număr întreg și data',
                    data: 'registru_number',
                    sortable: false,
                    render: (data: any, type: any, row: any) => {
                        if (row.registru_number) {
                            return `<span>${row.registru_number}</span><span>${row.registru_date}</span>`;
                        } else {
                            return '<span>N/A</span>';
                        }
                    },
                },
                {
                    title: 'Persoana fizică/juridică',
                    data: 'tip_persoana',
                    sortable: false,
                    render: (row: any) => {
                        if (row.tip_persoana === 1) {
                            return '<span>Fizică</span>';
                        } else if (row.tip_persoana === 2) {
                            return '<span>Juridică</span>';
                        } else {
                            return '<span>N/A</span>';
                        }
                    }
                },
                {
                    title: `Conținut`,
                    data: 'continut',
                    render: (data: any, type: any, row: any) => {
                        if (row.continut) {
                            return `<span>${row.continut}</span>`;
                        } else {
                            return '<span>N/A</span>';
                        }
                    },
                },
                {
                    title: 'Dată ieșire',
                    data: 'data_iesire',
                    sortable: false,
                    render: (data: any, type: any, row: any) => {
                        if (row.data_iesire) {
                            return `<span>${row.data_iesire}</span>`;
                        } else {
                            return '<span>Dată indisponibilă</span>';
                        }
                    },
                },
                {
                    title: 'Adresa lucrării',
                    data: 'adresa_domiciliu',
                    sortable: false,
                    render: (data: any, type: any, row: any) => {
                        if (row.adresa_domiciliu) {
                            return `<span>${row.adresa_domiciliu.strada}</span><span>${row.adresa_domiciliu.oras}</span>`;
                        } else {
                            return '<span>N/A</span>';
                        }
                    },
                },
                {
                    title: 'Întocmitor',
                    data: 'intocmitor',
                    sortable: false,
                    render: (data: any, type: any, row: any) => {
                        if (row.intocmitor) {
                            return `<span>${row.intocmitor}</span>`;
                        } else {
                            return '<span>N/A</span>';
                        }
                    },
                },
                {
                    title: 'Acțiuni',
                    data: null,
                    orderable: false,
                    className: 'all',
                    visible: false,
                    render: () => {
                        return `
                            <button class="action-btn edit">
                                <img class="btn-img" src="../../../../assets/icons/edit.svg" alt="edit"/>
                            </button>
                        `;
                    },
                },
            ],
            rowCallback: (row: Node, data: any[] | any) => {
                const lastTd = (row as HTMLElement).querySelector('td:last-child');
                const editIcon = lastTd?.querySelector('.edit') as HTMLElement;

                if (editIcon) {
                    editIcon.addEventListener('click', () => {
                        this.openEditDialog(data);
                    });
                }

                return row;
            },
        };
    }

    rerenderDT(paginate = false): void {
        this.isLoading = true;
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            this.isLoading = false;
            dtInstance.draw(paginate);
        });
    }

    openEditDialog(data: any) {
        const dialogRef = this.dialog.open(EditRegistruComponent, {
            ...this.dialogService.getDialogConfig(),
            data: { data, slug: this.registru_slug }
        });

        dialogRef.afterClosed().subscribe(({ success }: { success: boolean }) => {
            if (success) {
                Swal.fire({
                    title: helper.dialogConfig.headers.success,
                    text: 'Registru editat cu succes!',
                    icon: 'success',
                    confirmButtonText: helper.dialogConfig.buttonLabels.close,
                    allowOutsideClick: false,
                }).then(() => this.rerenderDT());
            }
        });
    }

    toggleEditColumnVisibility(): void {
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            dtInstance.columns(7).visible(this.isEditColumnVisible);
        });

        this.rerenderDT();
    }
}
